import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { MEMBER_MANAGER_TOKEN } from '../shared/consts/storage.const';
import { AuthStoreService } from './auth-store.service';

export const AuthenticationGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state,
) => {
    const router = inject(Router);
    const authStoreService = inject(AuthStoreService);
    const user = authStoreService.user();
    const accessToken =
        authStoreService.accessToken() ||
        localStorage.getItem(MEMBER_MANAGER_TOKEN);

    if (user?.email || !!accessToken) {
        return true;
    }

    const redirectUrl = state.url;
    router.navigate(['/auth'], {
        replaceUrl: true,
        queryParams: { redirectUrl },
    });

    return false;
};
